// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2lsCW","selects":"Documents_selects__1gfMc"};